import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={34}
    height={30}
    viewBox="0 0 34 30"
    fill="none"
    cursor="pointer"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.9}
      d="M26.8072 5.83242C26.776 5.83242 26.7445 5.83271 26.7132 5.83271C26.7152 5.78268 26.7161 5.73236 26.7161 5.68147C26.7161 2.54414 23.1463 0 18.7425 0C15.4842 0 12.6825 1.39225 11.4455 3.38748C10.9319 3.27599 10.3873 3.21566 9.82297 3.21566C6.75643 3.21566 4.27087 4.98673 4.27087 7.17123C4.27087 7.20639 4.27116 7.24213 4.27259 7.27701C1.82313 7.6884 0 9.25563 0 11.1268C0 13.3118 2.48556 15.0827 5.55209 15.0827C6.33287 15.0827 7.07579 14.968 7.74959 14.7605C8.74469 15.4855 10.1263 15.9346 11.653 15.9346C13.253 15.9346 14.6929 15.4415 15.6963 14.6547C16.6385 15.4418 17.9907 15.9346 19.4926 15.9346C21.1235 15.9346 22.5769 15.3534 23.5219 14.4469C24.4858 14.8505 25.6085 15.0827 26.8076 15.0827C30.3932 15.0827 33.2993 13.0117 33.2993 10.4579C33.2993 7.9035 30.3927 5.83252 26.8073 5.83252L26.8072 5.83242Z"
      fill={props.color}
    />
    <path
      d="M19.8713 18.0224C19.7636 17.9883 19.6023 17.9883 19.495 18.0566L12.7739 24.2165C12.7203 24.2851 12.7203 24.3534 12.7739 24.3877C12.8276 24.4563 12.9352 24.4904 12.9889 24.4904H16.0536L12.021 29.7264C11.9674 29.7949 12.021 29.8976 12.1287 29.9659C12.1823 29.9659 12.2364 30 12.29 30C12.3977 30 12.4513 29.9659 12.505 29.9315L19.2261 23.7715C19.2797 23.703 19.2797 23.6347 19.2261 23.6003C19.1724 23.5318 19.0648 23.4977 19.0111 23.4977H15.9464L19.979 18.2617C20.0326 18.1592 19.979 18.0566 19.8713 18.0224V18.0224Z"
      fill={props.color}
    />
    <rect
      x={7.63574}
      y={17.8184}
      width={0.727273}
      height={1.81818}
      rx={0.363636}
      fill={props.color}
    />
    <rect
      x={12.3633}
      y={17.8184}
      width={0.727273}
      height={1.81818}
      rx={0.363636}
      fill={props.color}
    />
    <rect
      x={17.0908}
      y={17.8184}
      width={0.727273}
      height={1.81818}
      rx={0.363636}
      fill={props.color}
    />
    <rect
      x={21.8179}
      y={17.8184}
      width={0.727273}
      height={1.81818}
      rx={0.363636}
      fill={props.color}
    />
    <rect
      x={26.5454}
      y={17.8184}
      width={0.727273}
      height={1.81818}
      rx={0.363636}
      fill={props.color}
    />
    <rect
      x={14.5454}
      y={22.1816}
      width={0.727273}
      height={1.81818}
      rx={0.363636}
      fill={props.color}
    />
    <rect
      x={19.999}
      y={22.1816}
      width={0.727273}
      height={1.81818}
      rx={0.363636}
      fill={props.color}
    />
  </svg>
);
export default SVGComponent;
